import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/apiClient';
import { useAuthStore } from '../store/authStore';

async function fetchMe() {
  const { data } = await api.get('/users/me');
  return data;
}

/** Loads and caches the authenticated user, syncing fresh data into the store. */
export function useCurrentUser() {
  const isAuthenticated = useAuthStore((s) => Boolean(s.accessToken));
  const setUser = useAuthStore((s) => s.setUser);

  const query = useQuery({
    queryKey: ['me'],
    queryFn: fetchMe,
    enabled: isAuthenticated,
    staleTime: 60_000,
  });

  useEffect(() => {
    if (query.data) setUser(query.data);
  }, [query.data, setUser]);

  return query;
}
